// @flow

import axios from 'axios';
import { getBaseUrl } from '../../config/config';

export default function getConstraintDelayApi(projectId: string, weekId: number): Promise<Object> {
  return axios.get(`${getBaseUrl()}projects/${projectId}/insights/delays?cmd=get_delays&work_delays=false${weekId ? `&week_id=${weekId}` : ''}`);
}
